<template>
    <vue-basic-alert
        :duration="300"
        :closeIn="10000"
        ref="alert" />
    <form class="settings__box-left-top" @submit="onSubmit">
        <p class="settings__box-heading">{{ $t('profile_settings.password_change') }}</p>
        <div class="control control--input">
            <label for="currentPassword" class="control__label">{{ $t('profile_settings.current_password') }}</label>
            <input
                type="password"
                id="currentPassword"
                :placeholder="$t('profile_settings.current_password_placeholder')"
                v-model="currentPassword"
                autocomplete="off"
                :class="{error: errors.currentPassword}"
            />
            <div v-show="errors.currentPassword" class="control__error">
                <div class="control__error-inner">
                    {{errors.currentPassword}}
                </div>
            </div>
        </div>
        <div class="control control--input">
            <label for="password" class="control__label">{{ $t('profile_settings.new_password') }}</label>
            <input
                type="password"
                id="password"
                :placeholder="$t('profile_settings.new_password_placeholder')"
                v-model="password"
                autocomplete="off"
                :class="{error: errors.password}"
            />
            <div v-show="errors.password" class="control__error">
                <div class="control__error-inner">
                    {{errors.password}}
                </div>
            </div>
        </div>
        <div class="control control--input">
            <label for="repeatPassword" class="control__label">{{ $t('profile_settings.confirm_password') }}</label>
            <input
                type="password"
                id="repeatPassword"
                :placeholder="$t('profile_settings.confirm_password_placeholder')"
                v-model="passwordConfirmation"
                autocomplete="off"
                :class="{error: errors.passwordConfirmation}"
            />
            <div v-show="errors.passwordConfirmation" class="control__error">
                <div class="control__error-inner">
                    {{errors.passwordConfirmation}}
                </div>
            </div>
        </div>
        <div class="settings__box-left-bottom">
            <button class="button-outline" type="submit" :disabled="sendingForm">{{ $t('profile_settings.update_information') }}</button>
        </div>
    </form>
</template>

<script>
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import i18n from "@/i18n";
import {ref} from "vue";
import axios from "axios";
import {useAuthStore} from "@/stores/auth.store";
import VueBasicAlert from "vue-basic-alert";
import ApiHelper from "@/helpsers/api.helper";
import AlertHelper from "@/helpsers/alert.helper";
import {useI18n} from "vue-i18n";
import authHelper from "@/helpsers/auth.helper";

export default {
    name: "ChangePassword",
    components: {
        VueBasicAlert
    },
    setup() {
        const sendingForm = ref(false);
        const alert = ref();
        const authStore = useAuthStore();
        const {t} = useI18n();

        const { handleSubmit, errors } = useForm({
            validationSchema: yup.object().shape({
                currentPassword: yup.string().trim()
                    .required(i18n.global.t('validate.required')),
                password: yup.string()
                    .required(i18n.global.t('validate.required'))
                    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, i18n.global.t('validate.password')),
                passwordConfirmation: yup.string()
                    .required(i18n.global.t('validate.required'))
                    .oneOf([yup.ref('password'), null], i18n.global.t('validate.passwordConfirmation')),
            }),
        });

        const { value: currentPassword } = useField('currentPassword');
        const { value: password } = useField('password');
        const { value: passwordConfirmation } = useField('passwordConfirmation');

        const onSubmit = handleSubmit(async (values, actions) => {
            sendingForm.value = true;
            const data = {
                currentPassword: values.currentPassword,
                newPassword: values.password,
            }

            axios.put(ApiHelper.getChangePasswordUrl(), data, {
                headers: authHelper.authHeader()
            }).then(response => {
                AlertHelper.show(alert, t('profile_settings.password_change_success'));

                actions.resetForm();
                sendingForm.value = false;
            }).catch(errorResponse => {
                let errorMessage = ApiHelper.getResponseMessage(errorResponse.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');

                sendingForm.value = false;
            })
        });

        return {
            currentPassword,
            password,
            passwordConfirmation,
            sendingForm,
            onSubmit,
            errors,
            alert
        }
    }
}
</script>

<style scoped lang="scss">
.control--input input {
    max-width: 100%;
}
</style>